module.exports = "<div class=\"pill-wrapper {{$ctrl.inverted()}} {{$ctrl.borderType($ctrl.border)}}\"> <i class=\"td-icon-xs icon-{{$ctrl.icon}}\" ng-if=$ctrl.icon></i><span ng-if=$ctrl.icon>{{$ctrl.textBefore}}</span> <span>{{$ctrl.text}}</span> <span ng-if=$ctrl.textAfter>{{$ctrl.textAfter}}</span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/information-pill/information-pill.html
// module id = 613
// module chunks = 0